export const demographicConstants = {
  SET_DEMOGRAPHIC_FIELD: 'SET_DEMOGRAPHIC_FIELD',
  SELECT_DEMOGRAPHIC_FIELD: 'SELECT_DEMOGRAPHIC_FIELD',
  RESET_DEMOGRAPHIC_STORE: 'RESET_DEMOGRAPHIC_STORE',
};
